import { LitElement, html, css } from 'lit';
import { jhaStyles } from '../../styles/jha-styles.js';
import '../../icons/jha-icon-chevron-down.js';

const JhaCollapsibleSectionOpenEvent = 'collapsible-section-opened';

const styles = css`
  :host {
    display: block;
    position: relative;
  }
  .toggle {
    background: var(--jha-background-color, #edeeef);
    margin: var(--jha-collapsible-section-header-margin, 0);
    border-radius: var(--jha-collapsible-section-header-border-radius, 0);
  }
  button.section-toggle {
    display: flex;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: var(--jha-collapsible-section-header-padding, 8px);
  }
  button[disabled] {
    opacity: var(--jha-button-disabled-opacity, 0.3);
    pointer-events: none;
    cursor: default;
  }
  jha-icon-chevron-down {
    fill: var(--jha-text-dark, #455564);
    transition: all 0.3s cubic-bezier(0.1, 0.5, 0.1, 1);
    padding: 4px;
  }
  :host([is-open]) jha-icon-chevron-down {
    transform: rotate(180deg);
  }
  /* jhaAccordianBody */
  article {
    height: 0;
    overflow: hidden;
    will-change: transform, opacity;
    opacity: var(--jha-accordion-body-opacity, 0.3);
    transition: all 0.3s cubic-bezier(0.1, 0.5, 0.1, 1);
    padding: 0;
    visibility: hidden;
  }
  :host([is-open]) article {
    height: auto;
    opacity: var(--jha-accordion-opacity, 1);
    padding: var(--jha-accordion-body-padding, 0);
    padding-top: var(--jha-accordion-open-body-padding-top, 16px);
    visibility: visible;
  }
`;

/**
 * @element jha-collapsible-section
 */
export default class JhaCollapsibleSection extends LitElement {
  static get styles() {
    return [jhaStyles, styles];
  }

  static get properties() {
    return {
      isOpen: {
        type: Boolean,
        attribute: 'is-open',
        reflect: true,
      },
      grouped: {
        type: Boolean,
      },
      headless: {
        type: Boolean,
      },
      disabled: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();
    this.isOpen = false;
    this.grouped = false;
    this.headless = false;
    this.disabled = false;
  }

  toggleContent() {
    if (this.disabled) return;

    this.isOpen = !this.isOpen;

    if (this.isOpen && this.grouped) {
      this.dispatchEvent(
        new CustomEvent(JhaCollapsibleSectionOpenEvent, {
          bubbles: true,
          composed: true,
        })
      );
    }
  }

  render() {
    return html`
      ${this.headless
        ? ''
        : html`
            <div class="toggle">
              <button
                class="section-toggle"
                button-reset
                @click="${this.toggleContent}"
                ?disabled=${this.disabled}
              >
                <slot name="header"> </slot>
                <jha-icon-chevron-down></jha-icon-chevron-down>
              </button>
            </div>
          `}
      <article>
        <slot name="body"></slot>
      </article>
    `;
  }
}

export {
  styles as JhaCollapsibleSectionStyles,
  JhaCollapsibleSectionOpenEvent,
};
